/**
 * Validation
 */

import { validationRules } from "./validation-rules";

const validation = (() => {
    let _o = {
        inputs: null,
        formSection: document.querySelector('.form'),
        formWrapper: document.querySelector('.form-wrapper'),
        selectors: {
            rules: "[data-validation-rules]",
            form: "[data-validation-form]",
        },
        fields: [],
    };

    let status = [];

    const init = () => {
        validationRules.init();
        initEvents();

    };

    const initEvents = () => {
        const forms = document.querySelectorAll(_o.selectors.form);
        const inputs = document.querySelectorAll(
            _o.selectors.form + " " + _o.selectors.rules
        );

        forms.forEach((form) => {
            form.addEventListener("submit", submitForm);
        });

        inputs.forEach((input) => {
            input.addEventListener("change", validateInput);
            input.addEventListener("focusout", validateInput);
        });

    };

    const submitForm = () => {
        event.preventDefault();
        status = [];
        const form = event.target;
        const inputs = form.querySelectorAll(_o.selectors.rules);
        const formElements = form.elements;
        const errorContainer = form.querySelector("[data-form-error]");
        const submitBtn = form.querySelector('[type="submit"]');

        inputs.forEach((input) => validateInput(input));

        setTimeout(() => {
            if (!status.includes(false)) {

                submitBtn.classList.add('disabled')

                grecaptcha.ready(() => {
                    grecaptcha
                        .execute('6LdvtbMmAAAAAN-oVhRmf_LXm3SkXkyxHyENaN6C', { action: 'submit' })
                        .then((token) => {

                            try {
                                let request = new XMLHttpRequest();
                                request.responseType = "json";

                                request.onreadystatechange = function () {
                                    if (request.status >= 200 && request.status < 300) {
                                        if (!request.response) return;

                                        const isError = request.response.error;

                                        if (isError) {
                                            _o.formSection.classList.add('error');
                                            _o.formWrapper.style.visibility = 'hidden';
                                        } else {
                                            _o.formSection.classList.add('success');
                                            _o.formWrapper.style.visibility = 'hidden';
                                        }


                                    } else if (request.status === 400) {
                                        const isError = request.response.error;

                                        if (isError) {
                                            _o.formSection.classList.add('code');
                                            _o.formWrapper.style.visibility = 'hidden';

                                            const codeError =  _o.formSection.querySelector('#code-error-desc');

                                            if(request.response.message == 'Invalid code') {
                                                codeError.innerHTML = 'Nieprawidłowy kod'
                                            }

                                            if(request.response.message == 'This code is already in use') {
                                                codeError.innerHTML = 'Kod został już wcześniej użyty'                                               
                                            }
                                        }
                                        else {

                                            if(request.response != null) {

                                                if(request.response.message) {
                                                    
                                                    const codeInput = document.getElementById('code');

                                                    const message = `<span class="tip">${request.response.messageContainer}</span>`;
                                                    codeInput.parentNode.classList.add("error");
                                                    setError(codeInput, request.response.error);

                                                    setFormError(errorContainer, message);
                                                }
                                                else {
                                                    const message = isError.message ? isError.message : "Nieznany błąd. Spróbuj ponownie za chwilę.";
                                                    setFormError(errorContainer, message);
                                                }
                                            }

                                            submitBtn.classList.add('error');
                                        }
                                    } else {
                                        // console.log(request.response);
                                    }
                                };

                                request.open("POST", form.action, true);
                                request.setRequestHeader('Content-Type', 'application/json')

                                // order of the append is important, file last!
                                //fd.append('recaptchaToken', token);

                                const fullName = `${formElements['name'].value} ${formElements['surname'].value}`;

                                const body = {
                                    "recaptchaToken": token,
                                    "answer": formElements['answer'].value,
                                    "code": formElements['code'].value,
                                    "fullName": fullName,
                                    "email": formElements['email'].value,
                                    "phone": formElements['phone'].value,
                                    "consent1": formElements['agreement18'].checked ? 'agreement18' : 'false',
                                    "consent2": formElements['agreementBuy'].checked ? 'agreementBuy' : 'false',
                                    "consent3": formElements['agreementRules'].checked ? 'agreementRules' : 'false',
                                    "consent4": formElements['agreementMarketing'].checked ? 'agreementMarketing' : 'false',
                                    "consent5": formElements['agreementEmail'].checked ? 'agreementEmail' : 'false',
                                    "consent6": formElements['agreementPhone'].checked ? 'agreementPhone' : 'false'
                                }

                                request.send(JSON.stringify(body));
                            } catch (error) {
                                submitBtn.classList.remove('disabled')
                            }
                        });
                });
            } else {
                const message = `
                    <span class="tip">Aby wysłać zgłoszenie, wypełnij wszystkie pola!</span>
                `
                submitBtn.classList.remove('disabled')

                setFormError(errorContainer, message);
            }
        });
    };


    const setFormError = (messageContainer, message) => {
        const isParagraph = messageContainer.querySelector("p");

        if (isParagraph) {
            isParagraph.innerHTML = message;
        } else {
            const paragraph = document.createElement("p");
            paragraph.innerHTML = message;
            messageContainer.appendChild(paragraph);
        }
    };

    const validateInput = (input) => {
        if (input.target) input = input.target;
        let isAnyError = false;

        let rules = getValidationRules(input);
        let type = input.getAttribute("type");
        let value = "";
        let validateResponse = '';

        switch (type) {
            case "checkbox":
                value = input.checked;
                break;
            case "file":
                if (input.files && input.files[0]) value = input.files[0];
                break;
            default:
                value = input.value;
        }

        for (let i = 0; i < rules.length; i++) {
            let currentRule = validationRules.returnValidationRule(rules[i]);
            validateResponse = currentRule(value, type);

            if (validateResponse.error) {
                isAnyError = true;
                break;
            } else {
                isAnyError = false;
            }
        }

        status.push(!isAnyError);

        if (isAnyError) {
            const requiredErrors = {
                code: 'Wpisz kod promocyjny.',
                name: 'Wpisz swoje imię.',
                surname: 'Wpisz swoje nazwisko.',
                answer: 'Wpisz odpowiedź',
                email: 'Wpisz adres email.',
                phone: 'Wpisz numer telefonu.',
                rePhone: 'Wpisz numer telefonu.',
                agreement18: 'Pole wymagane.',
                agreementBuy: 'Pole wymagane.',
                agreementRules: 'Pole wymagane.'
            }
            if (validateResponse.msg === 'required') {
                const message = `<span class="tip">${requiredErrors[input.name]}</span>`

                setError(input, message);



            } else {
                setError(input, validateResponse.msg);
            }
            return false
        } else {
            setSuccess(input, validateResponse.msg);
            return true
        }
    };

    const getValidationRules = (element) => {
        let data = element.dataset.validationRules;
        return data.split(",");
    };

    const setError = (element, msg) => {
        const container = element.parentNode;
        container.classList.remove("success");

        if (container.classList.contains("error")) {
            const alert = container.querySelector(".tooltip-wrapper");
            if (alert && !alert.classList.contains('static')) {
                alert.innerHTML = msg;
            }
        } else {
            container.classList.add("error");

            const alert = container.querySelector(".tooltip-wrapper");
            if (alert && !alert.classList.contains('static')) {
                alert.innerHTML = msg;
            }

        }
    };

    const setSuccess = (element, msg) => {
        const container = element.parentNode;
        const alert = container.querySelector(".tooltip-wrapper");
        if (alert && !alert.classList.contains('static'))
            alert.innerHTML = ''

        container.classList.remove("error");
    };

    return {
        init: init,
        validateInput: validateInput
    };
})();

export { validation };
